import SiafLiteApiRepository from "../../external/siafLiteApi";

class CaixaService {
  constructor() {
    this.urlBase = "/financeiro/caixa";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getRelatorios(data, bancoCaixaId, filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/relatorios`
    ).get(filter);
  }

  getTotaisDia(data, bancoCaixaId, filter) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/totais`
    ).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  caixaAberto(data, bancoCaixaId) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${data}/${bancoCaixaId}/aberto`
    ).get();
  }

  movimentar(id, movimentacaoCaixa) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/${id}/movimentar`).post(
      movimentacaoCaixa
    );
  }

  getRelatorioDetalhado(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/detalhado`
    ).patch(body);
  }

  tranferirSaldo(movimentacaoCaixa) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/transferir-saldo`).post(
      movimentacaoCaixa
    );
  }
}

export default CaixaService;
